import React from "react";

import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@mui/material/Button";
import { useEffect, useState, useRef } from "react";
import {
  createModel,
  fetchBrandList,
  fetchCategoryList,
  fetchSubCategoryList,
  fetchModelList,
  updateModelStatus,
  updateModel,
  fetchSubCategoryListActive,
  filterHsnCode,
  exportModel,
  importModel,
  downloadModelReferenceCode,
} from "../../../API Service/apiService";
import ProductTabs from "../../../Componants/Common/product tabs/ProductTabs";
import {
  Autocomplete,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonButton from "../../../Componants/Common/Button";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import BulkUploadToast from "../../../Componants/Common/Bulk Upload/BulkUploadToast";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import deleteIcon from "../../../Assests/deleteIcon.svg";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import { downloadFile } from "../../../utils/downloadHelper";
import Paginate from "../../../Componants/Common/Paginate";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import BulkUploadSection from "../../../Componants/Common/Bulk Upload/BulkUploadSection";
import FileSaver from "file-saver";

const cells = [
  "S.No",
  "Brand",
  "Category",
  "Sub Category",
  "Model Name",
  "Serialized",
  "Action",
];
const serials = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const modelheader = [
  { label: "Brand", key: "brandName" },
  { label: "Category", key: "categoryName" },
  { label: "Sub Category", key: "subcategoryName" },
  { label: "Model Name", key: "modelName" },
  { label: "Serialized", key: "isSerialized" },
  { label: "Status", key: "active" },
];

const ManageModel = () => {
  const topRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [modelListDropdown, setModelListDropdown] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [modelName, setModelName] = useState("");
  const [modelCode, setModelCode] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [isSerialized, setIsSerialized] = useState(null);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [subcategoryId, setSubCategoryId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [modelList, setModelList] = useState([]);
  const [editIndex, setEditIndex] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [subcategoryName, setSubcategoryName] = useState("");
  const [dataSize, setDataSize] = useState(10);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [totalRecords, setTotalRecords] = useState(null);
  const [brandName, setBrandName] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [filteredCat, setfilteredCat] = useState([]);
  const [filteredSubCat, setfilteredSubCat] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [filteredMod, setFilteredMod] = useState([]);
  const [selectedCategory2, setselectedCategory2] = useState(null);
  const [selectedBrandId2, setselectedBrandId2] = useState(null);
  const [filteredCat2, setfilteredCat2] = useState([]);
  const [brandName2, setBrandName2] = useState(null);
  const [categoryId2, setCategoryId2] = useState(null);
  const [subcategoryName2, setSubcategoryName2] = useState(null);
  const [filteredSubCat2, setfilteredSubCat2] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [subcategoryId2, setSubcategoryId2] = useState(null);
  const [modelName2, setModelName2] = useState(null);
  const [activeBrandList, setActiveBrandList] = useState([]);
  const [brandError, setBrandError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [subCategoryError, setSubCategoryError] = useState(false);
  const [modelNameError, setModelNameError] = useState(false);
  const [modelCodeError, setModelCodeError] = useState(false);
  const [hsnCodeError, setHsnCodeError] = useState(false);
  const [serializedError, setSerializedError] = useState(false);
  const [activeFilteredCat, setActiveFilteredCat] = useState([]);
  const [activeFilteredSubCat, setActiveFilteredSubCat] = useState([]);
  const [status, setStatus] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [flag, setFlag] = useState(false);
  const [error, setError] = useState(null);
  const [hsnCodes, setHsnCodes] = useState([]);
  const [bulkFile, setBulkFile] = useState(null);

  // Pagination and Search Parameters
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // Fixed limit as in Managebrand
  const [searchParams, setSearchParams] = useState({
    modelName: "",
    page: 1,
    limit: 10,
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    status: "",
  });

  const dummyGetList = {
    serialNo: "",
    brandName: "",
    categoryName: "",
    description: "",
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setSearchParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  const getBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandList();
      setBrandList(response.data.brandList);
      const filteredActiveBrands = response.data.brandList.filter(
        (brand) => brand.active === true
      );
      setActiveBrandList(filteredActiveBrands);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBrandList();
  }, []);

  const fetchHsnCodes = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await filterHsnCode();
      setHsnCodes(data.taxes);
    } catch (err) {
      setError("Failed to fetch HSN codes");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHsnCodes();
  }, []);

  const handleFetchCategories = async () => {
    if (selectedBrandId) {
      try {
        setLoading(true);
        const response = await fetchCategoryList(
          selectedBrandId,
          "",
          1,
          limit,
          status
        );
        setfilteredCat(response.data.categories);
      } catch (error) {
        console.error(`Error in filter list`, error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    handleFetchCategories();
  }, [selectedBrandId]);

  const handleFetchCategories2 = async () => {
    if (selectedBrandId2) {
      try {
        setLoading(true);
        const response = await fetchCategoryList(
          selectedBrandId2,
          "",
          1,
          limit
        );
        setfilteredCat2(response.data.categories || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    handleFetchCategories2();
  }, [selectedBrandId2]);

  const handleFetchSubCategories = async () => {
    if (categoryId) {
      try {
        setLoading(true);
        const response = await fetchSubCategoryListActive(
          "",
          1,
          limit,
          selectedBrandId,
          categoryId,
          status
        );
        setfilteredSubCat(response.data.subcategory);
      } catch (error) {
        console.error(`Error in filter list`, error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    handleFetchSubCategories();
  }, [categoryId]);

  const handleFetchSubCategories2 = async () => {
    if (categoryId2) {
      try {
        setLoading(true);
        const response = await fetchSubCategoryList(
          subcategoryName,
          1,
          limit,
          selectedBrandId2,
          categoryId2
        );
        setfilteredSubCat2(response.data.subcategory || []);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    handleFetchSubCategories2();
  }, [categoryId2]);

  const handleStatus = async (modelId) => {
    try {
      setLoading(true);
      const response = await updateModelStatus({ modelId: modelId });
      if (response.status === "success") {
        toast.success("Status Updated Successfully");
      }
      getAllModelList(searchParams);
    } catch (error) {
      console.log(`Error updating status ${error}`);
      toast.error(`Failed to update status`);
    } finally {
      setLoading(false);
    }
  };

  const getAllModelList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchModelList(params);
      setModelList(response.data.models || []);
      setTotalRecords(response.data.totalModels);
      setTableData(response.data.models);
    } catch (error) {
      console.error("Error fetching Modellist:", error);
    } finally {
      setLoading(false);
    }
  };

  const getModelDropdown = async (subcategoryId) => {
    try {
      setLoading(true);
      const params = {
        brandId: selectedBrandId2,
        categoryId: categoryId2,
        subcategoryId: subcategoryId,
      };
      const response = await fetchModelList(params);
      setModelListDropdown(response.data.models || []);
    } catch (error) {
      console.error("Error fetching Modellist:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlemodelfetch = async () => {
    try {
      if (subcategoryId2) {
        setLoading(true);
        const response = await fetchModelList(
          modelName,
          1,
          limit,
          selectedBrandId2,
          categoryId2,
          subcategoryId2
        );
        setFilteredMod(response.data.models || []);
      }
    } catch (error) {
      console.error("Error fetching Modellist:", error);
    }
    setLoading(false);
  };

  const handleSearch = async () => {
    const updatedParams = {
      ...searchParams,
      modelName: modelName2,
      brandId: selectedBrandId2,
      categoryId: categoryId2,
      subcategoryId: subcategoryId2,
      page: 1, // Reset to page 1 on search
    };
    setSearchParams(updatedParams);
    setPage(1); // Reset page state
    setIsSearching(true);
    try {
      setLoading(true);
      const response = await fetchModelList(updatedParams);
      setTableData(response.data.models || []);
      setTotalRecords(response.data.totalModels || 0);
      if (response.data.totalModels > 10) {
        setFlag(true);
      }
    } catch (error) {
      console.log(`Error in filter List`, error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchCancel = () => {
    const updatedParams = {
      ...searchParams,
      modelName: "",
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      page: 1,
    };
    setSearchParams(updatedParams);
    setPage(1); // Reset page state
    setBrandName2("");
    setselectedBrandId2("");
    setselectedCategory2("");
    setCategoryId2("");
    setSubcategoryName2("");
    setSubcategoryId2("");
    setModelName2("");
    setfilteredCat2([]);
    setfilteredSubCat2([]);
    setFilteredMod([]);
    setModelListDropdown([]);
    setIsSearching(false);
    setFlag(false);
    getAllModelList(updatedParams);
  };

  useEffect(() => {
    const updatedParams = { ...searchParams, page };
    setSearchParams(updatedParams);
    getAllModelList(updatedParams);
  }, [page]);

  const handleCancel = async () => {
    setBrandId(null);
    setBrandName("");
    setSubcategoryName("");
    setSelectedBrandId("");
    setSelectedCategory(null);
    setCategoryId("");
    setSelectedBrand(null);
    setSubCategoryId(null);
    setModelName("");
    setModelCode("");
    setHsnCode("");
    setIsSerialized(null);
    setEditIndex(false);
    setSelectedCategoryName("");
    setfilteredCat([]);
    setfilteredSubCat([]);
    setIsEditing(false);
    setBrandError(false);
    setCategoryError(false);
    setSubCategoryError(false);
    setModelNameError(false);
    setModelCodeError(false);
    setHsnCodeError(false);
    setSerializedError(false);
  };

  const handleSave = async () => {
    let isValid = true;

    if (!selectedBrandId) {
      setBrandError(true);
      isValid = false;
    } else {
      setBrandError(false);
    }

    if (!categoryId) {
      setCategoryError(true);
      isValid = false;
    } else {
      setCategoryError(false);
    }

    if (!subcategoryId) {
      setSubCategoryError(true);
      isValid = false;
    } else {
      setSubCategoryError(false);
    }

    if (!modelName) {
      setModelNameError(true);
      isValid = false;
    } else {
      setModelNameError(false);
    }

    if (!modelCode) {
      setModelCodeError(true);
      isValid = false;
    } else {
      setModelCodeError(false);
    }

    if (!hsnCode) {
      setHsnCodeError(true);
      isValid = false;
    } else {
      setHsnCodeError(false);
    }

    if (isSerialized === null) {
      setSerializedError(true);
      isValid = false;
    } else {
      setSerializedError(false);
    }

    if (!isValid) {
      toast.error("Please fill all the fields");
      return;
    } else {
      const requestData = {
        brandId: selectedBrandId,
        categoryId: categoryId,
        subcategoryId: subcategoryId,
        modelName: modelName,
        modelCode: modelCode,
        hsnCode: hsnCode.hsnCode,
        isSerialized: isSerialized,
      };
      try {
        setLoading(true);
        if (!editIndex) {
          const response = await createModel(requestData);
          if (response?.status === "success") {
            toast.success("Model saved successfully!");
            handleCancel();
          } else {
            toast.error(response?.message);
          }
        } else {
          const updateData = { _id: editIndex, active: true, ...requestData };
          const response = await updateModel(updateData);
          if (response?.status === "success") {
            toast.success("Model saved successfully!");
            handleCancel();
          } else {
            toast.error(response?.message);
          }
          setEditIndex(false);
        }
        getAllModelList(searchParams);
      } catch (error) {
        console.log(`Error updating status ${error}`);
        toast.error(error.response.data.message);
      } finally {
        setIsEditing(false);
        setLoading(false);
      }
    }
  };

  const handleEdit = (
    modelId,
    brandId,
    brandName,
    categoryId,
    categoryName,
    subcategoryId,
    subcategoryName,
    modelName,
    modelCode,
    hsnCode,
    isSerialized
  ) => {
    setIsEditing(true);
    setBrandName(brandName);
    setSelectedCategoryName(categoryName);
    setSubcategoryName(subcategoryName);
    setEditIndex(modelId);
    setSelectedBrandId(brandId);
    setCategoryId(categoryId);
    setSubCategoryId(subcategoryId);
    setModelName(modelName);
    setModelCode(modelCode);
    const selectedHsnObject = hsnCodes.find((code) => code.hsnCode === hsnCode);
    setHsnCode(selectedHsnObject || null);
    setIsSerialized(isSerialized);

    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const params = {
        modelName: modelName2,
        brandId: selectedBrandId2,
        categoryId: categoryId2,
        subcategoryId: subcategoryId2,
      };
      const response = await exportModel(params);
      if (response?.status === "success" && response?.data?.filePath) {
        downloadFile(response.data.filePath);
        toast.success("File downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error in export model:", error);
      toast.error(error.message || "Failed to export models");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadModelTemplate = () => {
    downloadFile(`${process.env.REACT_APP_TEMPLETE_URL}/excel/Model.xlsx`);
    toast.success("Model Template downloaded successfully!");
  };

  const handleDownloadReference = async () => {
    try {
      setLoading(true);
      const response = await downloadModelReferenceCode();
      if (response?.status === "success" && response?.data?.filePath) {
        downloadFile(response.data.filePath);
        toast.success("Reference code downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error in download reference code:", error);
      toast.error(error.message || "Failed to download reference code");
    } finally {
      setLoading(false);
    }
  };

  const handleBulkFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "xlsx" && fileExtension !== "xls") {
        toast.error("Only Excel files (.xlsx, .xls) are allowed");
        event.target.value = null; // Clear the input
        return;
      }
      setBulkFile(file);
    }
  };

  const handleBulkUpload = async () => {
    if (!bulkFile) {
      toast.error("Please select a file to upload");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", bulkFile);
      const response = await importModel(formData);
      console.log("response", response);
      if (response.status == "error") {
        toast((t) => <BulkUploadToast t={t} response={response} />, {
          duration: Infinity,
        });
        setBulkFile(null);
        getAllModelList(searchParams);
      } else if (response.status == "success") {
        toast.success(response?.message || "Model bulk upload successfully!");
        setBulkFile(null);
        getAllModelList(searchParams);
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      toast.error(error.response?.data?.message || "Something went wrong during Bulk Upload");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container ref={topRef}>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Product > Model"} location={"/setting"} />
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <ProductTabs selectedTab="four" />
        </Grid>
        <Grid container gap={5}>
          <Grid item>
            <Autocomplete
              id="brand-autocomplete"
              closeOnSelect
              options={activeBrandList}
              value={
                selectedBrand || (brandName ? { brandName: brandName } : null)
              }
              getOptionLabel={(option) => option.brandName || ""}
              onChange={(event, value) => {
                const brandId = value?._id || null;
                setSelectedBrand(value);
                setBrandName(value ? value.brandName : "");
                setSelectedBrandId(brandId);
                setBrandError(false);
                setIsEditing(false);
                setSelectedCategory("");
                setCategoryId("");
                setSelectedCategoryName("");
                setSubcategoryName("");
                setSubCategoryId("");
                setfilteredSubCat([]);
                setfilteredCat([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand *"
                  variant="standard"
                  style={{ width: "10rem" }}
                  error={brandError}
                  helperText={brandError ? "Brand is required." : ""}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={filteredCat}
              value={
                selectedCategory ||
                (selectedCategoryName
                  ? { categoryName: selectedCategoryName }
                  : null)
              }
              getOptionLabel={(option) => option.categoryName || ""}
              onChange={(event, newValue) => {
                setSelectedCategory(newValue);
                setSelectedCategoryName(newValue ? newValue.categoryName : "");
                setCategoryId(newValue ? newValue._id : "");
                setCategoryError(false);
                setSubcategoryName("");
                setSubCategoryId("");
                setfilteredSubCat([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category *"
                  variant="standard"
                  style={{ width: "10rem" }}
                  error={categoryError}
                  helperText={categoryError ? "Category is required." : ""}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={filteredSubCat}
              value={
                subcategoryName ? { subcategoryName: subcategoryName } : null
              }
              getOptionLabel={(option) => option.subcategoryName || ""}
              onChange={(event, newValue) => {
                setSubcategoryName(newValue ? newValue.subcategoryName : "");
                setSubCategoryId(newValue ? newValue._id : "");
                setSubCategoryError(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="SubCategory *"
                  variant="standard"
                  style={{ width: "10rem" }}
                  error={subCategoryError}
                  helperText={
                    subCategoryError ? "SubCategory is required." : ""
                  }
                />
              )}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "90%" }}
              id="model-name"
              label="Model Name *"
              variant="standard"
              value={modelName}
              focused={!!editIndex}
              onChange={(e) => {
                setModelName(e.target.value);
                setModelNameError(false);
              }}
              error={modelNameError}
              helperText={modelNameError ? "Model Name is required." : ""}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "90%" }}
              id="model-code"
              label="Model Code *"
              variant="standard"
              value={modelCode}
              onChange={(e) => {
                setModelCode(e.target.value);
                setModelCodeError(false);
              }}
              error={modelCodeError}
              helperText={modelCodeError ? "Model Code is required." : ""}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={hsnCodes}
              getOptionLabel={(option) => option.hsnCode || ""}
              value={
                hsnCodes.find((code) => code.hsnCode === hsnCode?.hsnCode) ||
                null
              }
              onChange={(event, value) => {
                setHsnCode(value);
                setHsnCodeError(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={{ width: "11rem" }}
                  label="HSN Code *"
                  variant="standard"
                  error={hsnCodeError}
                  helperText={hsnCodeError ? "HSN Code is required." : ""}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              CloseOnSelect
              options={serials}
              getOptionLabel={(option) => option.label}
              value={
                isSerialized === null
                  ? null
                  : serials.find(
                    (option) => option.label === (isSerialized ? "Yes" : "No")
                  ) || null
              }
              onChange={(e, val) => {
                setIsSerialized(val ? val.label === "Yes" : null);
                setSerializedError(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Is Serialized"
                  variant="standard"
                  style={{ width: "11rem" }}
                  error={serializedError}
                  helperText={serializedError ? "Is Serialized is required." : ""}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container gap={2} spacing={5} sx={{ marginTop: "1rem" }}>
          <Grid item>
            <CommonButton
              name={editIndex === false ? "Save" : "Update"}
              handleOnClick={handleSave}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
          </Grid>
        </Grid>
      </Grid>

      <BulkUploadSection
        onFileChange={handleBulkFileChange}
        onUpload={handleBulkUpload}
        onDownloadTemplate={handleDownloadModelTemplate} // Add template download function if available
        onDownloadReference={handleDownloadReference}
        fileName={bulkFile?.name}
      />

      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <Typography variant="h6">List View</Typography>
        </Grid>
        <Grid container gap={5}>
          <Grid item>
            <Autocomplete
              id="brand-autocomplete"
              closeOnSelect
              options={activeBrandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={brandName2 ? { brandName: brandName2 } : null}
              onChange={(event, value) => {
                const brandId = value ? value._id : "";
                const brandName = value ? value.brandName : "";
                setBrandName2(brandName);
                setselectedBrandId2(brandId);
                setselectedCategory2("");
                setCategoryId2("");
                setfilteredCat2([]);
                setSubcategoryName2("");
                setSubcategoryId2(null);
                setModelName2(null);
                setfilteredSubCat2([]);
                setFilteredMod([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  style={{ width: "10rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={filteredCat2}
              getOptionLabel={(option) => option.categoryName || ""}
              value={
                selectedCategory2 ? { categoryName: selectedCategory2 } : null
              }
              onChange={(event, newValue) => {
                const categoryName = newValue ? newValue.categoryName : "";
                const categoryId = newValue ? newValue._id : "";
                setselectedCategory2(categoryName);
                setCategoryId2(categoryId);
                setSubcategoryName2("");
                setfilteredSubCat2([]);
                setModelName2("");
                setFilteredMod([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  variant="standard"
                  style={{ width: "10rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={filteredSubCat2}
              getOptionLabel={(option) => option.subcategoryName || ""}
              value={
                filteredSubCat2.find(
                  (item) => item.subcategoryName === subcategoryName2
                ) || null
              }
              onChange={(event, newValue) => {
                const selectedSubcategoryName = newValue
                  ? newValue.subcategoryName
                  : "";
                const selectedSubcategoryId = newValue ? newValue._id : "";
                setSubcategoryName2(selectedSubcategoryName);
                setSubcategoryId2(selectedSubcategoryId);
                if (!newValue) {
                  setSubcategoryName2("");
                  setModelName2(null);
                  setSubcategoryId2("");
                  setFilteredMod([]);
                } else {
                  getModelDropdown(selectedSubcategoryId);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subcategory"
                  variant="standard"
                  style={{ width: "10rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={modelListDropdown}
              getOptionLabel={(option) => option.modelName || ""}
              value={
                modelListDropdown.find((mod) => mod.modelName === modelName2) ||
                null
              }
              onChange={(event, newValue) => {
                setModelName2(newValue ? newValue.modelName : "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Model"
                  variant="standard"
                  style={{ width: "10rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Search"} handleOnClick={handleSearch} />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleSearchCancel} />
          </Grid>
        </Grid>

        <Grid container>
          <Grid container justifyContent="flex-end">
            <ExportToExcel name="Export to Excel" onClick={handleExport} />
          </Grid>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        textAlign:
                          index === cells.length - 1 ? "right" : "center",
                        paddingRight: index === cells.length - 1 ? "4rem" : "",
                      }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length > 0 ? (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(searchParams.page - 1) * searchParams.limit + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.brandName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.categoryName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.subcategoryName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.modelName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {row.isSerialized ? "Yes" : "No"}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          onClick={() => handleStatus(row._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={
                              row.active === false ? inactiveIcon : activeIcon
                            }
                            alt="active"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            handleEdit(
                              row._id,
                              row.brandId,
                              row.brandName,
                              row.categoryId,
                              row.categoryName,
                              row.subcategoryId,
                              row.subcategoryName,
                              row.modelName,
                              row.modelCode,
                              row.hsnCode,
                              row.isSerialized
                            )
                          }
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                      <Typography variant="body1">No Data Available</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <div
          className="pagination-container"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default ManageModel;